<template>
  <div class="row p-1 mt-3 bg-white">
    <div class="row p-2">
        <div class="col" style="margin-left: 30px;">
            <a-dropdown>
                <template #overlay>
                    <a-menu @click="updateQueryDuration">
                        <a-menu-item key="LastThreeMonth">
                            <CalendarTwoTone />&nbsp;三個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastSixMonth">
                            <CalendarTwoTone />&nbsp;六個月內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastYear">
                            <CalendarTwoTone />&nbsp;一年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="LastTwoYear">
                            <CalendarTwoTone />&nbsp;兩年內 - 新增之專案
                        </a-menu-item>
                        <a-menu-item key="AllYears">
                            <CalendarTwoTone />&nbsp;所有已新增之專案
                        </a-menu-item>
                    </a-menu>
                </template>
                <a-button>
                    <CalendarTwoTone />{{ ProjectQueryDurationNames.get(reportForm.queryDuration) }}&nbsp;<DownOutlined />
                </a-button>
            </a-dropdown>
        </div>
    </div>
    <div class="row p-1">
        <div class="col">
              <div class="chart">
                <canvas ref="barChart"></canvas>
              </div>
          </div>
        </div>
        <div class="p-1 mt-1">
          <div class="col">
            <div class="paginate">
              <paginate-module ref="paginateVue" 
                @onFetchPage="updateChartByPageNumber" 
                :totalItems="reportForm.totalItemNumber" 
                :items-per-page="reportForm.itemsPerPage" />
            </div>
          </div>
        </div>
    </div>
</template>
<script setup>
import { CalendarTwoTone, DownOutlined } from "@ant-design/icons-vue";
import { ProjectQueryDurationNames } from "@/common";
import { ref, reactive, onMounted } from "vue";
import Chart from "chart.js/auto";
import PaginateModule from '@/components/PaginateModule.vue';
import config from "@/config";
import common from "@/common";

var reportBarChart = null;
const barChart = ref();
const paginateVue = ref();
const reportForm = reactive({});
reportForm.itemsPerPage = 8;
reportForm.totalItemNumber = 0;

const updateQueryDuration = (menuItem) => {
    if (reportForm.queryDuration === menuItem.key) {
        return ;
    }
    reportForm.queryDuration = menuItem.key;
    common.saveQueryDuration(reportForm.queryDuration);
    updateBarChartByQueryDuration();
}

const createBarChart = (barChartData) => {
    const ctx = barChart.value.getContext("2d");
    reportBarChart = new Chart(ctx, {
        type: "bar",
        data: barChartData,
        options: {
            indexAxis: "y",
            plugins: {
                legend: {
                    labels: {
                        font: {
                            size: 16
                        }
                    }
                },
                title: {
                    display: false
                }
            },
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                    ticks: {
                        font: {
                            size: 14
                        },
                        callback: function(value) {
                            var valueLabel = this.getLabelForValue(value);
                            return valueLabel.split('\n');
                        }
                    }
                }
            }
        }
    });
};

const getDataRequestBody = (pageNumber) => {
    return {
        duration: reportForm.queryDuration,
        pagingCriteria: {
          pageNumber: pageNumber,
          itemsPerPage: reportForm.itemsPerPage
        }
    }
}

const getTotalRequestBody = () => {
    return {
        duration: reportForm.queryDuration
    };
}

const updateBarChartByQueryDuration = () => {
    common.postRequest(config.projectCompletenessTotal, getTotalRequestBody(), (response) => {
        reportForm.totalItemNumber = response.data.total;
    });
    paginateVue.value.fetchPage(1);
}

const updateChartByPageNumber = (pageNumber) => {
    common.postRequest(config.projectCompletenessChartData, getDataRequestBody(pageNumber), (response) => {
        console.log("[Project-Completeness] Update BarChartData by QueryDuration: " + reportForm.queryDuration + " and PageNumber: " + pageNumber);
        if (reportBarChart == null) {
            createBarChart(response.data);
        } else {
            reportBarChart.data = response.data;
            reportBarChart.update();
        }
    });
}

onMounted(() => {
    reportForm.queryDuration = common.getQueryDuration("LastThreeMonth");
    updateBarChartByQueryDuration();
});

</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
canvas {
    padding-left: 0;
    padding-right: 0;
    margin-left: auto;
    margin-right: auto;
    display: block;
    width: 90%;
}
 /* .chart {
    width: 99%;
    height: 580px;
    margin-bottom: 5px;
    text-align: center;
  }  */
  .paginate {
    width: 99%;
  }
</style>
